import { render, staticRenderFns } from "./TranServicePackageCreateDetail.vue?vue&type=template&id=743f11bd"
import script from "./TranServicePackageCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranServicePackageCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranServicePackageCreateDetail.vue?vue&type=style&index=0&id=743f11bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports